import { Injectable } from "@angular/core";
import { BaseModel } from "./base-model";
import { HttpService } from "app/services/http.service";
import { AppConstants } from "../vo/app-constants";

@Injectable()
export class SettingModelService extends BaseModel {
	public settingXMLData: any;
	private objResponse = {};
	constructor(private httpService: HttpService) {
		super();
	}
	public initialize(data: any) {
		this.loadSettingXML(data);
	}
	private loadSettingXML(url) {
		this.httpService
			.getXmlData(url + AppConstants.SETTING_XML_PATH)
			.then((res: Response) => {
				this.objResponse["response"] = "success";
				this.objResponse["data"] = res;
				this.parseSettingXML(res);
			})
			.catch((error) => {
				this.objResponse["response"] = "error";
				this.objResponse["data"] = null;
				this._notifier.next(this.objResponse);
			});
	}
	private parseSettingXML(data) {
		this.settingXMLData = data;
		this._notifier.next(this.objResponse);
	}
}
